import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import { constants } from 'cng-web-lib'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  const errMsgAlphaNumericWithSpecialChar = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR
  )

  const errMsgMaxLength = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )

  const regexAlphaNumericWithSpecialChar =
    '^[a-zA-Z0-9 ,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\ ]+$'

  return Yup.object({
    billNo: Yup.string().nullable(),
    parentBillNo: Yup.string().nullable(),
    partyType: Yup.string().nullable().required(requiredMessage),
    partyIdentificationType: Yup.string().nullable().when('partyType', {
      is: (val) => val === 'CN' || val === 'CZ',
      then: (schema) => schema.required(requiredMessage),
      otherwise: (schema) => schema.nullable()
    }),
    partyId: Yup.string().nullable().max(35, errMsgMaxLength + " 35"),
    establishmentOrIndividual: Yup.string().nullable(),
    partyName: Yup.string().nullable().required(requiredMessage).matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(70, errMsgMaxLength + " 70"),
    street: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(256, errMsgMaxLength + " 256"),
    streetNumber: Yup.string().nullable().max(256, errMsgMaxLength + " 256"),
    postalCode: Yup.string().nullable().max(256, errMsgMaxLength + " 256"),
    city: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(35, errMsgMaxLength + " 35"),
    country: Yup.string().nullable().max(2, errMsgMaxLength + " 2"),
    contactLevel: Yup.string().nullable(),
    contactName: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(256, errMsgMaxLength + " 256"),
    telephoneNumber: Yup.string().nullable().max(512, errMsgMaxLength + " 512"),
    emailId: Yup.string().nullable().max(512, errMsgMaxLength + " 512"),
    url: Yup.string().nullable().max(512, errMsgMaxLength + " 512"),
    forwardingNotes: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(512, errMsgMaxLength + " 512"),
  })
}

export default makeValidationSchema
